import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { UpdateDashboardValidationSchema } from '../../schemas/dashboards/dashboard.schema';

interface UseUpdateDashboardProps {
  dashboardId: string | undefined,
  options?: Partial<Omit<UseMutationOptions<
    unknown,
    ErrorResponse,
    UpdateDashboardValidationSchema
  >, 'mutationKey' | 'mutationFn'>>;
}

export const useUpdateDashboard = ({ dashboardId, options }: UseUpdateDashboardProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['updateDashboard', dashboardId],
    mutationFn: (form) => {
      return privateAxios.put(`/dashboards/${dashboardId}`, {
        dashboard: {
          display_name: form.display_name?.trim(),
          desired_filters: form.desired_filters || [],
        },
      });
    },
    ...options,
  });
}
